
import {
  sidebarNavActive,
  sidebarRowCountColSx,
  sidebarRowGridSx,
  sidebarRowNameSx,
} from '@/layout-blueprints/chromeComponentSx'
import React from 'react'
import { NavLink, Link, useLocation } from 'react-router'
import HomeTwoToneIcon from '@mui/icons-material/HomeTwoTone'
import ChevronRightTwoToneIcon from '@mui/icons-material/ChevronRightTwoTone'
import Collapse from '@mui/material/Collapse'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
// Centralized lodash imports - much cleaner!
import { filter, includes } from '@/utils/lodash'
import {Divider, Box } from '@mui/material'

const SubmittedPropertiesSection = (props) => {
  const {
    session,
    submittedDropdownOpen,
    toggleSubmittedDropdown,
    handlePortfolio,
    handleMarketplace,
    activeMarketplaceId,
  } = props
  const submittedProperties =
    session?.me?.activeOrg?.submittedProperties
  const marketPlaces = session?.me?.activeOrg?.marketPlaces

  // Only show if there is at least one actual option
  const hasSubmittedOptions =
    submittedProperties?.lender ||
    submittedProperties?.jv ||
    (Array.isArray(submittedProperties?.sharedMarketplaces) &&
      submittedProperties.sharedMarketplaces.length > 0) ||
    submittedProperties?.housefolios

  if (!hasSubmittedOptions) {
    return null
  }

  // Log if the dropdown is rendered but empty
  if (
    !submittedProperties.lender &&
    !submittedProperties.jv &&
    (!Array.isArray(submittedProperties.sharedMarketplaces) ||
      submittedProperties.sharedMarketplaces.length === 0) &&
    !submittedProperties.housefolios
  ) {
    console.log(
      '[SubmittedPropertiesSection] Dropdown rendered but no menu options.',
      {
        submittedProperties,
        marketPlaces,
        session},
    )
  }

  const handleToggleDropdown = (e) => {
    console.log(
      '[SubmittedPropertiesSection] Toggling dropdown. Current open:',
      submittedDropdownOpen,
    )
    if (toggleSubmittedDropdown) toggleSubmittedDropdown(e)
  }

  const onSubmittedMarketplacePage = useLocation().pathname.startsWith(
    '/submitted-marketplace',
  )

  return (
    <>
      <Divider />
      <ul>
        <li>
          <a
            id="leftNavSettings"
            href="#/"
            onClick={handleToggleDropdown}
            data-nav-active={submittedDropdownOpen || undefined}
          >
            <span data-hf="sidebar-icon">
              <HomeTwoToneIcon />
            </span>
            <span data-hf="sidebar-item-label">
              Submitted Properties
            </span>
            <span data-hf="sidebar-icon-indicator">
              <ChevronRightTwoToneIcon />
            </span>
          </a>
          <Collapse in={submittedDropdownOpen}>
            <ul>
              {submittedProperties.lender && (
                <li key="submitted-lender">
                  <NavLink
                    id="leftNavSettingsPersonal"
                    onClick={() =>
                      handlePortfolio && handlePortfolio(null)
                    }
                    to="/submitted-lender-properties"
                  >
                    Lender
                  </NavLink>
                </li>
              )}
              {submittedProperties.jv && (
                <li key="submitted-jv">
                  <NavLink
                    id="leftNavSettingsPersonal"
                    onClick={() =>
                      handlePortfolio && handlePortfolio(null)
                    }
                    to="/submitted-jv-properties"
                  >
                    JV Deals
                  </NavLink>
                </li>
              )}
              {filter(marketPlaces, (marketplace) =>
                includes(
                  submittedProperties.sharedMarketplaces,
                  marketplace.url,
                ),
              ).map((marketplace, index) => (
                <li
                  key={marketplace.url || `submitted-marketplace-${index}`}
                  data-hf="hover-show-hide-container"
                >
                  <Box sx={{
                    "& [data-hf-hover=\"show\"]": { display: "none" },
                    "& [data-hf-hover=\"hide\"]": { display: "block" },
                    "&:hover [data-hf-hover=\"show\"]": { display: "block" },
                    "&:hover [data-hf-hover=\"hide\"]": { display: "none" },
                  }}>
                    <Link
                      onClick={() =>
                        handleMarketplace &&
                        handleMarketplace(marketplace.url)
                      }
                      to="/submitted-marketplace"
                      {...sidebarNavActive(
                        String(activeMarketplaceId) ===
                          String(marketplace.url),
                        onSubmittedMarketplacePage,
                      )}
                    >
                      <Grid
                        container
                        direction="row"
                        wrap="nowrap"
                        sx={sidebarRowGridSx}
                      >
                        <Grid size="grow">
                          <Typography sx={sidebarRowNameSx} noWrap>
                            {marketplace.name}
                          </Typography>
                        </Grid>
                        <Grid size="auto" sx={sidebarRowCountColSx}>
                          <Typography>
                            {marketplace.submittedPropertyCount || 0}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Link>
                  </Box>
                </li>
              ))}
              {submittedProperties.housefolios && (
                <li key="submitted-housefolios">
                  <Link
                    id="leftNavMarketplacesHousefoliosMarketplace"
                    onClick={() =>
                      handleMarketplace && handleMarketplace(null)
                    }
                    to="/submitted-marketplace"
                    {...sidebarNavActive(
                      !activeMarketplaceId,
                      onSubmittedMarketplacePage,
                    )}
                  >
                    {'Housefolios Marketplace'}
                  </Link>
                </li>
              )}
            </ul>
          </Collapse>
        </li>
      </ul>
    </>
  );
}

export default SubmittedPropertiesSection
